<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const { galleryItems, activeItem, getImageFromProvider } = useUiMediaGallery(props.name)
const { settings } = useUiDialog(props.name)
const isZoom = ref<boolean>(false)

const toggleZoom = (event) => {
  isZoom.value = !isZoom.value

  nextTick(() => {
    const container = event.currentTarget;
    container.scrollLeft = (container.scrollWidth - container.clientWidth) / 2;
    container.scrollTop = (container.scrollHeight - container.clientHeight) / 2;
  });
}

watch(activeItem, (newValue, oldValue) => {
  if (newValue?.index !== oldValue?.index) {
    isZoom.value = false
  }
})

watch(() => settings.value.isOpen, (isOpen) => {
  if (!isOpen) {
    isZoom.value = false
  }
})

</script>

<template>
  <div
    class="media-gallery-fullscreen-main"
    :class="{
      'media-gallery-fullscreen-main--zoom': isZoom,
    }"
  >
    <ul class="media-gallery-fullscreen-main__list">
      <li
        v-for="item in galleryItems"
        v-show="activeItem?.index === item.index"
        :key="item.src"
        class="media-gallery-fullscreen-main__item"
        :data-item="item.index"
        @click="toggleZoom"
      >
        <UiVideo
          v-if="item.type === 'video'"
          :src="item.src"
          width="720"
          height="870"
          :autoplay="activeItem?.index === item.index"
          :controls="true"
          playsinline
          loop
          muted
          class="media-gallery-fullscreen-main__video"
        />

        <div
          v-else-if="item.type === 'image'"
          class="media-gallery-fullscreen-main__contents"
        >
          <img
            :src="getImageFromProvider(item)"
            :alt="item.alt"
            width="720"
            height="870"
            loading="lazy"
            class="media-gallery-fullscreen-main__image"
          >
        </div>
      </li>
    </ul>
  </div>
</template>

<style>
@import url("~layers/app/components/Ui/MediaGallery/FullscreenMain.css");
</style>
